<div class="input-container">
  @if (selectedFile()) {
    <div class="file-preview">
      @if (filePreviewUrl()) {
        <img
          [src]="filePreviewUrl()"
          class="preview-thumb"
          alt="Preview"
        />
      } @else {
        <span class="material-symbols-outlined">description</span>
      }
      <span class="file-name">{{ selectedFile()!.name }}</span>
      <button
        class="clear-file"
        (click)="clearFile()"
      >
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  }

  <div class="input-row">
    <button
      class="attach-btn"
      (click)="openFilePicker()"
      type="button"
    >
      <span class="material-symbols-outlined">attach_file</span>
    </button>

    <div class="media-anchor">
      <button
        class="media-btn"
        (click)="toggleMediaPicker()"
        type="button"
      >
        <span class="material-symbols-outlined">emoji_emotions</span>
      </button>
      <app-media-picker
        [isOpen]="mediaPickerOpen()"
        (emojiSelected)="onEmojiSelected($event)"
        (mediaSelected)="onMediaSelected($event)"
        (closed)="closeMediaPicker()"
      />
    </div>

    <input
      #fileInput
      type="file"
      hidden
      (change)="onFileSelect($event)"
      accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip"
    />

    <input
      #messageInput
      type="text"
      class="message-input"
      [placeholder]="translateService.getTranslation(4153)"
      [ngModel]="messageText()"
      (ngModelChange)="messageText.set($event)"
      (keydown)="onKeydown($event)"
      (input)="onInput()"
    />

    <button
      class="send-btn"
      (click)="onSend()"
      [disabled]="!messageText().trim() && !selectedFile()"
      type="button"
    >
      <span class="material-symbols-outlined">arrow_forward</span>
    </button>
  </div>
</div>
